import { Size, sizeToCSS } from '#utils/UNSAFE_size';
import { fallbackVar } from '#UNSAFE_Theme/utils';
import { layoutLocalVars } from '#utils/UNSAFE_styles/Layout/LayoutStyles.css';
import { LayoutColumnSpan } from '#utils/UNSAFE_styles/Layout';

const CssUnitsRegex = /^([+-]?(?:\d+|\d*\.\d+))([a-z]*|%)$/;

// (originally copied from rt/src/main/javascript/oracle/oj/ojvformgenerator/ojvstartlabeler.tsx)
/**
 * Calculate the width of a start label, taking into account the column span.
 * @param labelStartWidth specified width of the start label
 * @param columnSpan  number of columns to span
 * @returns start label width to use
 */
function computeStartLabelWidth(labelStartWidth: Size, columnSpan: LayoutColumnSpan) {
  const origWidth = sizeToCSS(labelStartWidth);
  const labelWidth = origWidth === 0 ? '0' : origWidth;
  const actualColumnCount = fallbackVar(layoutLocalVars.actualColumnCount, '1');
  const actualColumnGapWidth = fallbackVar(layoutLocalVars.actualColumnGapWidth, '0');
  const actualColSpan = `min(${columnSpan},${actualColumnCount})`;

  if (columnSpan > 1) {
    // for units that are (or can be) relative to horizontal screen size.
    // for '%' labelWidth, we need to divide the value by the number of columns this component
    // is spanning (which can be less than the colspan property value);
    const parts = labelWidth.match(CssUnitsRegex);
    if (parts === null) {
      return labelWidth;
    }

    const labelWidthNumber = parseFloat(parts[1]);
    const labelWidthUnits = parts[2];

    switch (labelWidthUnits) {
      case 'vw':
      case 'vmin':
      case 'vmax':
      case '%':
        return (
          `calc( ( (${labelWidth} / ${actualColSpan}) - ` +
          `( ${actualColumnGapWidth} * ` +
          `(${actualColSpan} - 1) * ` +
          `(${labelWidthNumber}/${actualColSpan}/100) ) ) )`
        );
      default:
        break;
    }
  }

  return labelWidth;
}

export { computeStartLabelWidth };
